import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Breadcrumbs, Link, Box } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';
import { formError, ROLE_USER } from '@utils/helpers';
import Layout from '@components/Layout';
import UserForm from '@components/user/UserForm';
import useLocalStorage from '@/hooks/useLocalStorage'; 

function UserCreatePage() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { showMessage } = useSnackbar();
    const form = useRef();
    const [searchValues] = useLocalStorage('users.searchValues', {});

    const [initialData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        lang: i18n.language,
        active: true,
        password: '',
        password_confirmation: '',
        password_force_change: true,
        role: ROLE_USER,
        customer_id: searchValues.customer_id || '', // Par défaut = client recherché sur la page de liste
    });

    const handleSubmit = async (data) => {
        try {
            delete data.password_confirmation;
            const result = await API.post(`/users`, data);
            showMessage(t('User created successfully'), 'success');
            navigate(`/users/${result.data.id}`);
        } catch (error) {
            formError(error, t, form.current.setError, showMessage);
        }
    };

    return (
        <Layout>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link component={RouterLink} to="/users" underline="hover">{t('User management')}</Link>
                    <Typography>{t('Create user')}</Typography>
                </Breadcrumbs>
                <Link component={RouterLink} to="/users" underline="hover" sx={{ display: 'flex', alignItems: 'center' }}>
                    <ArrowBackIcon sx={{ mr: 0.5 }} />
                    {t('Back to list')}
                </Link>
            </Box>
            <UserForm onSubmit={handleSubmit} ref={form} initialData={initialData} passwordRequired={true} />
        </Layout>
    );
}

export default UserCreatePage;
